import Box from '@mui/material/Box'
import {useEffect, useState} from 'react'
import ApiService from '../../../common/ApiCalls'
import {Select, Text} from '../../1elements'

const ContactTypeDropDown = ({value, onChange}) => {
    const [options, setOptions] = useState([])

    const getServiceTypeOptions = async () => {
        const contactTypes = await ApiService().getAllContactType()
        const contactTypesWithoutUser = contactTypes.filter((contactType) => contactType.contact_type !== 'User')
        setOptions(contactTypesWithoutUser)
    }

    useEffect(()=>{
        getServiceTypeOptions()
    }, [])

    return (
        <Box sx={{ maxWidth: '400px' }}>
            <Text type={'fieldLabel'}>Contact Type</Text>
            <Select options={options} optionLabelKey={'contact_type'} value={value} onChange={onChange} helperText={'Select One'}
                    optionIdKey={'contact_type'}/>
        </Box>
    )
}

export default ContactTypeDropDown
